import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useField } from "formik";
import { inputMessageKeyframe } from "styles";

// assets
import DangerIcon from "assets/icons/danger-icon.svg";
import SuccessIcon from "assets/icons/success-icon.svg";

const TextInput = ({ label, successMsg, marginBottom, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <Wrapper marginBottom={marginBottom}>
      {label && <Label htmlFor={field.name}>{label}</Label>}
      <Input {...field} {...props} />

      {meta.error && meta.touched ? (
        <Message className="error">
          <img src={DangerIcon} />
          {meta.error}
        </Message>
      ) : null}

      {!meta.error && meta.touched && successMsg ? (
        <Message className="success">
          <img src={SuccessIcon} />
          {successMsg}
        </Message>
      ) : null}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "16px"};
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${(props) => props.theme.colors.inputLabel};
  margin-bottom: 8px;
  line-height: 18px;
`;

const Input = styled.input`
  height: 48px;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 8px;
  font-size: 16px;
  :focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.inputActive};
  }
`;

const Message = styled.div`
  font-size: 12px;
  margin-top: 6px;
  animation: ${inputMessageKeyframe} 0.5s;

  &.error {
    color: #da2e2e;
  }

  &.success {
    color: #004fec;
  }

  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    margin-right: 6px;
  }
`;

TextInput.propTypes = {
  label: PropTypes.string,
  successMsg: PropTypes.string,
  marginBottom: PropTypes.string,
};

TextInput.defaultProps = {
  label: null,
  successMsg: null,
  marginBottom: "",
};

export default TextInput;
